import http from './http';

/**
 * Obtiene todos los videos de splash disponibles si esta adjunto al rol.
 */
export async function listSplashVideos() {
  const res = await http.get('/splash/video');
  return res.data?.data ?? res.data ?? [];
}

/**
 * Sube un nuevo video de splash.
 */
export async function uploadSplashVideo(file, role) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('role', role);
//   if (typeof order !== 'undefined' && order !== null) {
//     formData.append('order', order);
//   }

  const res = await http.post(`/splash/video`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return res.data?.data ?? res.data;
}

/**
 * Elimina un video de splash por ID.
 */
export async function deleteSplashVideo(id) {
  const res = await http.delete(`/splash/${id}`);
  return res.data?.data ?? res.data;
}


